// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Tooltip, Box, Typography, Container, IconButton, Avatar, AppBar, Toolbar, Button, useTheme, useMediaQuery } from '@mui/material';
// import backgroundImage from '../Icon/Background2.png';
// import Footer2 from './Footer2';
// import Header from '../Header/Header';
// import Header1 from '../Header/Header1';
// import CertificateImage from '../Icon/Startup_India_Certificate.png';
// import Startup_Karnataka_Registration from './Startup_Karnataka_Registration.png'
// import VisionBackground from '../Icon/Vission_latest.png';
// import MissionBackground from '../Icon/mi1.png';
// import Slider from 'react-slick';
// import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
// import JourneyPage from '../Home/JourneyPage';
// import { FaBrain, FaRobot, FaProjectDiagram } from 'react-icons/fa';
// import { MdAssistant, MdDataUsage } from 'react-icons/md';
// import { 
//   AiOutlineCloud,
//   AiOutlineMobile,
//   AiOutlineApi,
// } from 'react-icons/ai';
// import {
//   Grid,
//   Card,
//   CardContent,
//   CardHeader,
//   Divider,
//   Paper,
//   Icon,
// } from '@mui/material';
// import {
//   AiFillRobot,
//   AiOutlineCode,
//   AiOutlineGlobal,
//   AiOutlineDeploymentUnit,
//   AiOutlineBulb,
//   AiOutlineFlag,
//   AiOutlineSafety,
//   AiOutlineUser,
//   AiOutlineTeam,
//   AiOutlineRocket,
//   AiOutlineInfoCircle,
//   AiOutlineTrophy,
// } from 'react-icons/ai';
// import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
// import LocationOnIcon from '@mui/icons-material/LocationOn';
// import { styled } from '@mui/material/styles';
// import { AiOutlineAim, AiOutlineEye } from 'react-icons/ai';
// import Appointments from './Appointments';
// import TeamPage from './TeamPage';
// import AchievementSection2 from '../Achievements/AchievementSection2';
// import AboutHeroSection from './AboutHeroSection';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Pagination, Autoplay } from 'swiper/modules';

// import 'swiper/css';
// import 'swiper/css/pagination';


// const API_URL = process.env.REACT_APP_API_URL;

// const sliderSettings = {
//   dots: true,
//   infinite: true,
//   speed: 500,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   arrows: false,
//   autoplay: true,
//   autoplaySpeed: 3000,
//   appendDots: dots => (
//     <div
//       style={{
//         position: 'absolute',
//         bottom: window.innerWidth < 600 ? '-20px' : window.innerWidth < 960 ? '-25px' : '-30px',
//         width: '100%',
//         display: 'flex',
//         justifyContent: 'center',
//       }}
//     >
//       <ul style={{
//         margin: '0px',
//         padding: '0px',
//         display: 'flex',
//         gap: window.innerWidth < 600 ? '1px' : '5px' // Smaller gap for small screens
//       }}>
//         {dots}
//       </ul>
//     </div>
//   ),

//   customPaging: () => (
//     <div
//       style={{
//         width: '12px',
//         height: '12px',
//         borderRadius: '50%',
//         backgroundColor: 'white',
//         opacity: 0.5,
//       }}
//     />
//   )
// };



// function AboutUs({ userId, loggedIn, onLogout }) {
//   const navigate = useNavigate();

//   const scrollToTop = () => {
//     window.scrollTo({ top: 0, behavior: 'smooth' });
//   };

//   const scrollToSection = (id) => {
//     document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
//   };

//   const handleLogout = () => {
//     onLogout(); // Call the passed logout function
//     navigate('/login'); // Navigate to login page after logout
//   };

//   const theme = useTheme();
//   const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

//   const HoverableCardHeader = styled(CardHeader)(({ theme }) => ({
//     transition: 'color 0.3s',
//     '&:hover .MuiCardHeader-title': {
//       color: '#1E90FF', // Change title color to blue on hover
//     },
//   }));



//   const address = "No 26, Laskar Hosur Road, Adugodi, Bangalore South, Bengaluru, Karnataka 560030, India";

//   const location = {
//     lat: 12.936373,  // Latitude
//     lng: 77.611114 // Longitude
//   };

//   const MAP_LIBRARIES = ['marker'];

//   const [selectedLocation, setSelectedLocation] = useState(null);
//   const [mapLoaded, setMapLoaded] = useState(false);

//   const darkModeStyles = [
//     {
//       "elementType": "geometry",
//       "stylers": [
//         { "color": "#212121" }
//       ]
//     },
//     {
//       "elementType": "labels.icon",
//       "stylers": [
//         { "visibility": "off" }
//       ]
//     },
//     {
//       "elementType": "labels.text.fill",
//       "stylers": [
//         { "color": "#757575" }
//       ]
//     },
//     {
//       "elementType": "labels.text.stroke",
//       "stylers": [
//         { "color": "#212121" }
//       ]
//     },
//     {
//       "featureType": "administrative",
//       "elementType": "geometry",
//       "stylers": [
//         { "visibility": "off" }
//       ]
//     },
//     {
//       "featureType": "landscape",
//       "elementType": "geometry",
//       "stylers": [
//         { "color": "#262626" }
//       ]
//     },
//     {
//       "featureType": "poi",
//       "elementType": "geometry",
//       "stylers": [
//         { "color": "#212121" }
//       ]
//     },
//     {
//       "featureType": "water",
//       "elementType": "geometry",
//       "stylers": [
//         { "color": "#000000" }
//       ]
//     },
//     {
//       "featureType": "road",
//       "elementType": "geometry",
//       "stylers": [
//         { "color": "#2c2c2c" }
//       ]
//     },
//     {
//       "featureType": "road",
//       "elementType": "labels.text.fill",
//       "stylers": [
//         { "color": "#8b8686" }
//       ]
//     },
//   ];

//   const options = {
//     styles: darkModeStyles,
//     disableDefaultUI: true, // Optional: Disable default UI
//   };

//   const mapContainerStyle = {
//     width: '100%',
//     height: '400px'
//   };

//   useEffect(() => {
//     const checkGoogleMaps = () => {
//       if (window.google && window.google.maps) {
//         setMapLoaded(true);
//       } else {
//         console.error("Google Maps not loaded yet");
//       }
//     };

//     window.addEventListener('load', checkGoogleMaps);

//     return () => {
//       window.removeEventListener('load', checkGoogleMaps);
//     };
//   }, []);

//   const technologies = [
//   {
//     title: 'Artificial Intelligence',
//     icon: <FaBrain size={40} color="#1E90FF" />,
//     content: 'Building capable and safe AI models for real-world applications.',
//   },
//   {
//     title: 'Machine Learning',
//     icon: <AiOutlineBulb size={40} color="#1E90FF" />,
//     content: 'Utilizing ML techniques to enhance user experience and deliver insights.',
//   },
//   {
//     title: 'Natural Language Processing',
//     icon: <AiOutlineGlobal size={40} color="#1E90FF" />,
//     content: 'Researching advanced NLP methods to understand and generate human language.',
//   },
//   {
//     title: 'Large Language Models (LLMs)',
//     icon: <AiOutlineCode size={40} color="#1E90FF" />,
//     content: 'Fine-tuning and building cutting-edge language models for diverse use cases.',
//   },
//   {
//     title: 'AI Agents & Assistants',
//     icon: <MdAssistant size={40} color="#1E90FF" />,
//     content: 'Developing intelligent AI agents and virtual assistants for automation and support.',
//   },
//   {
//     title: 'Deep Learning',
//     icon: <FaRobot size={40} color="#1E90FF" />,
//     content: 'Applying deep neural networks to solve complex problems efficiently.',
//   },
//   {
//     title: 'Retrieval-Augmented Generation (RAG)',
//     icon: <AiOutlineApi size={40} color="#1E90FF" />,
//     content: 'Building hybrid models combining retrieval and generation techniques.',
//   },
//   {
//     title: 'Data Science',
//     icon: <MdDataUsage size={40} color="#1E90FF" />,
//     content: 'Analyzing and interpreting complex data to optimize AI model performance.',
//   },
 
//   {
//     title: 'AI Ethics & Safety',
//     icon: <FaProjectDiagram size={40} color="#1E90FF" />,
//     content: 'Ensuring responsible, ethical AI design and deployment.',
//   },
// ];

//   const values = [
//     {
//       title: 'Freedom',
//       icon: <AiOutlineFlag size={40} />,
//       description: 'The power to act, speak or think as one wants without hindrance or restraint.',
//     },
//     {
//       title: 'Discipline',
//       icon: <AiOutlineSafety size={40} />,
//       description: 'The practice of following a standard code of behavior.',
//     },
//     {
//       title: 'Equality',
//       icon: <AiOutlineUser size={40} />,
//       description: 'The state of being equal, especially in status, rights and opportunities.',
//     },
//   ];


//   useEffect(() => {
//     // Scroll to top when the component mounts
//     window.scrollTo(0, 0);

//     const handlePopState = (event) => {
//       navigate('/home'); // If you want to navigate to home on back button press
//     };

//     window.addEventListener('popstate', handlePopState);

//     return () => {
//       window.removeEventListener('popstate', handlePopState);
//     };
//   }, [navigate]);

//    const items = [
//     {
//       title: 'Mission',
//       text: 'Democratize access to expertise by combining human intelligence with trusted AI systems.',
//       icon: <AiOutlineAim size={50} color="#1E90FF" />,
//     },
//     {
//       title: 'Vision',
//       text: 'A world where knowledge flows instantly, accurately, and responsibly—across borders, industries, and languages.',
//       icon: <AiOutlineEye size={50} color="#1E90FF" />,
//     },
//   ];


//   return (
//     <div>
      
//       <Header1 />
//       <AboutHeroSection/>
      
//       <div
//         style={{
//           minHeight: '100vh',
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//           // backgroundImage: `url(${backgroundImage})`,
//           backgroundColor: 'black',
//           backgroundSize: 'cover',
//           backgroundPosition: 'center',
//           color: 'white',
//           padding: '20px',
//           marginTop: 10,
//           paddingTop: '80px',
//           paddingBottom: '100px',
//         }}
//       >
//         <div
//           style={{
//             flexGrow: 1,
//             display: 'flex',
//             flexDirection: 'column',
//             justifyContent: 'center',
//             alignItems: 'center',
//             width: '100%',
//             padding: '0 20px', // Add horizontal padding
//           }}
//         >


//          <Container
//       id="mission_and_vision"
//       sx={{
//         my: { xs: 10, sm: 12, md: 14 },
//         maxWidth: '1000px',
//         margin: '0 auto',
//         px: { xs: 2, sm: 4, md: 6 },
//       }}
//     >
//       <Typography
//         variant="h4"
//         align="center"
//         gutterBottom
//         sx={{
//           letterSpacing: 6,
//           fontWeight: '700',
//           mb: 6,
//           color: 'white',
//           textTransform: 'uppercase',
//           position: 'relative',
//           '&:hover': { color: '#1E90FF' },
//           '&::after': {
//             content: '""',
//             display: 'block',
//             width: 60,
//             height: 4,
//             bgcolor: '#1E90FF',
//             borderRadius: 2,
//             margin: '12px auto 0',
//           },
//         }}
//       >
//         Mission & Vision
//       </Typography>

//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: { xs: 'column', md: 'row' },
//           gap: { xs: 4, md: 6 },
//           justifyContent: 'center',
//           alignItems: 'stretch',
//         }}
//       >
//         {items.map((item, index) => (
//           <Box
//             key={index}
//             sx={{
//               flex: 1,
//               position: 'relative',
//               background: 'rgba(30, 144, 255, 0.1)',
//               borderRadius: '20px',
//               padding: { xs: 4, sm: 6 },
//               boxShadow: '0 8px 32px 0 rgba(30, 144, 255, 0.2)',
//               backdropFilter: 'blur(12px)',
//               WebkitBackdropFilter: 'blur(12px)',
//               border: '1px solid rgba(255, 255, 255, 0.15)',
//               textAlign: 'center',
//               color: 'white',
//               display: 'flex',
//               flexDirection: 'column',
//               justifyContent: 'center',
//               cursor: 'default',
//               transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//               '&:hover': {
//                 transform: 'translateY(-10px)',
//                 boxShadow: '0 12px 40px 0 rgba(30, 144, 255, 0.5)',
//               },
//             }}
//           >
//             <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
//               {item.icon}
//             </Box>

//             <Typography
//               variant="h5"
//               sx={{
//                 fontWeight: 700,
//                 letterSpacing: 6,
//                 fontSize: { xs: '1.8rem', sm: '2.2rem' },
//                 mb: 3,
//                 textTransform: 'uppercase',
//                 position: 'relative',
//                 '&::after': {
//                   content: '""',
//                   position: 'absolute',
//                   left: '50%',
//                   transform: 'translateX(-50%)',
//                   bottom: -10,
//                   width: 50,
//                   height: 3,
//                   bgcolor: '#1E90FF',
//                   borderRadius: 2,
//                 },
//               }}
//             >
//               {item.title}
//             </Typography>

//             <Typography
//               variant="body1"
//               sx={{
//                 fontStyle: 'italic',
//                 fontSize: { xs: '1rem', sm: '1.1rem' },
//                 letterSpacing: 1.8,
//                 lineHeight: 1.7,
//                 maxWidth: '90%',
//                 mx: 'auto',
//                 color: 'rgba(255, 255, 255, 0.85)',
//               }}
//             >
//               &quot;{item.text}&quot;
//             </Typography>
//           </Box>
//         ))}
//       </Box>
//     </Container>



//           <Container
//       id="team"
//       maxWidth="lg"
//       sx={{
//         bgcolor: 'black',
//         minHeight: '100vh',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'center',
//         alignItems: 'center',
//         color: 'white',
//         py: { xs: 6, md: 10 },
//         mb: 10,
//       }}
//     >
//       <Typography
//         variant="h3"
//         align="center"
//         gutterBottom
//         sx={{
//           letterSpacing: 6,
//           fontWeight: 'bold',
//           textTransform: 'uppercase',
//           color: '#ffffff',
//           position: 'relative',
//           display: 'inline-block',
//           mb: 6,
//           '&::after': {
//             content: '""',
//             position: 'absolute',
//             width: '60%',
//             height: '4px',
//             bottom: -8,
//             left: '20%',
//             background: 'linear-gradient(90deg, #1E90FF, #00C9FF)',
//             borderRadius: 2,
//           },
//           '&:hover': {
//             color: '#1E90FF',
//           },
//         }}
//       >
//         Our Team
//       </Typography>

//       <Box
//         sx={{
//           width: '100%',
//           maxWidth: { xs: '90%', md: '800px' },
//           display: 'flex',
//           justifyContent: 'center',
//           alignItems: 'center',
//         }}
//       >
//         <Card
//           elevation={6}
//           sx={{
//             background: 'linear-gradient(145deg, #000000ff, #000000ff)',
//             borderRadius: '16px',
//             overflow: 'hidden',
//             transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//             '&:hover': {
//               transform: 'translateY(-6px)',
//               boxShadow: '0 12px 24px rgba(30, 144, 255, 0.3)',
//             },
//             width: '100%',
//           }}
//         >
//           <Box
//             sx={{
//               display: 'flex',
//               justifyContent: 'center',
//               alignItems: 'center',
//               pt: 4,
//             }}
//           >
//             <AiOutlineTeam size={60} style={{ color: '#1E90FF' }} />
//           </Box>

//           <CardContent sx={{ px: 5, py: 4 }}>
//             <Typography
//               variant="h5"
//               align="center"
//               gutterBottom
//               sx={{
//                 fontWeight: 600,
//                 letterSpacing: 4,
//                 color: '#ffffff',
//                 mb: 3,
//                 '&:hover': {
//                   color: '#1E90FF',
//                 },
//               }}
//             >
//               Passionate & Dedicated
//             </Typography>

//             <Typography
//               variant="body1"
//               align="center"
//               sx={{
//                 color: '#cfcfcf',
//                 lineHeight: 1.8,
//                 letterSpacing: 1,
//               }}
//             >
//               Our team at Anthrasync consists of highly passionate, dedicated and motivated individuals who are continuously working towards one common goal. 
//               We are always willing to take risks, face challenges and overcome them. We make sure that we are regularly updating our skills and are part of a continuous process of learning and growth.
//             </Typography>
//           </CardContent>
//         </Card>
//       </Box>
//     </Container>


//           <Container
//   id="values"
//   maxWidth="lg"
//   sx={{
//     bgcolor: '#000000',
//     minHeight: '60vh',
//     color: 'white',
//     py: { xs: 6, md: 10 },
//     mb: 20,
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//   }}
// >
//   <Typography
//     variant="h3"
//     align="center"
//     gutterBottom
//     sx={{
//       letterSpacing: 5,
//       fontWeight: 'bold',
//       textTransform: 'uppercase',
//       position: 'relative',
//       mb: 6,
//       '&::after': {
//         content: '""',
//         position: 'absolute',
//         width: '60%',
//         height: '4px',
//         bottom: -8,
//         left: '20%',
//         background: 'linear-gradient(90deg, #1E90FF, #00C9FF)',
//         borderRadius: 2,
//       },
//       '&:hover': {
//         color: '#1E90FF',
//       },
//     }}
//   >
//     Our Core Values
//   </Typography>

//   <Box sx={{ width: '100%', maxWidth: '1100px' }}>
//     <Swiper
//       modules={[Pagination, Autoplay]}
//       spaceBetween={30}
//       pagination={{ clickable: true }}
//       autoplay={{
//         delay: 3500,
//         disableOnInteraction: false,
//       }}
//       breakpoints={{
//         0: { slidesPerView: 1 },
//         600: { slidesPerView: 2 },
//         960: { slidesPerView: 3 },
//       }}
//       style={{
//         paddingBottom: '60px',
//         '--swiper-pagination-color': '#1E90FF',
//         '--swiper-pagination-bullet-inactive-color': '#ffffff',
//         '--swiper-pagination-bullet-inactive-opacity': '0.6',
//         '--swiper-pagination-bullet-size': '10px',
//         '--swiper-pagination-bullet-horizontal-gap': '8px',
//       }}
//     >
//       {values.map((value, index) => (
//         <SwiperSlide key={index}>
//           <Card
//             elevation={6}
//             sx={{
//               background: 'linear-gradient(145deg, #000000ff, #000000ff)',
//               borderRadius: '16px',
//               height: '100%',
//               transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//               display: 'flex',
//               flexDirection: 'column',
//               alignItems: 'center',
//               textAlign: 'center',
//               '&:hover': {
//                 transform: 'translateY(-6px)',
//                 boxShadow: '0 12px 24px rgba(30, 144, 255, 0.3)',
//               },
//             }}
//           >
//             <Box sx={{ pt: 4 }}>
//               <Avatar
//                 sx={{
//                   backgroundColor: 'transparent',
//                   color: '#1E90FF',
//                   width: 56,
//                   height: 56,
//                 }}
//               >
//                 {value.icon}
//               </Avatar>
//             </Box>

//             <CardContent sx={{ px: 4, py: 3 }}>
//               <Typography
//                 variant="h6"
//                 sx={{
//                   mb: 2,
//                   color: '#ffffff',
//                   fontWeight: 600,
//                   letterSpacing: 2,
//                 }}
//               >
//                 {value.title}
//               </Typography>

//               <Typography
//                 variant="body2"
//                 sx={{
//                   color: '#cfcfcf',
//                   letterSpacing: 1,
//                   lineHeight: 1.7,
//                 }}
//               >
//                 {value.description}
//               </Typography>
//             </CardContent>
//           </Card>
//         </SwiperSlide>
//       ))}
//     </Swiper>
//   </Box>
// </Container>

//          <Container
//   id="technologies"
//   maxWidth="lg"
//   sx={{
//     bgcolor: '#000000',
//     color: 'white',
//     py: { xs: 6, md: 10 },
//     borderRadius: 2,
//     textAlign: 'center',
//   }}
// >
//   <Typography
//     variant="h3"
//     gutterBottom
//     sx={{
//       letterSpacing: 5,
//       fontWeight: 'bold',
//       textTransform: 'uppercase',
//       mb: 6,
//       position: 'relative',
//       '&::after': {
//         content: '""',
//         position: 'absolute',
//         width: '60%',
//         height: '4px',
//         bottom: -8,
//         left: '20%',
//         background: 'linear-gradient(90deg, #1E90FF, #00C9FF)',
//         borderRadius: 2,
//       },
//     }}
//   >
//     Technologies We Deal With
//   </Typography>

//   <Swiper
//   modules={[Pagination, Autoplay]}
//   spaceBetween={30}
//   pagination={{ clickable: true }}
//   autoplay={{ delay: 3000, disableOnInteraction: false }}
//   breakpoints={{
//     0: { slidesPerView: 1 },
//     600: { slidesPerView: 2 },
//     960: { slidesPerView: 3 },
//     1280: { slidesPerView: 4 },
//   }}
//   style={{
//     paddingBottom: '60px',
//     '--swiper-pagination-color': '#1E90FF',            // active dot
//     '--swiper-pagination-bullet-inactive-color': '#fff', // inactive dots
//     '--swiper-pagination-bullet-inactive-opacity': '0.6',
//     '--swiper-pagination-bullet-size': '10px',
//     '--swiper-pagination-bullet-horizontal-gap': '8px',
//   }}
// >

//     {technologies.map((tech, index) => (
//       <SwiperSlide key={index}>
//         <Card
//           elevation={6}
//           sx={{
//             background: '#000',
//             borderRadius: '16px',
//             height: '100%',
//             transition: '0.3s',
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//             textAlign: 'center',
//             '&:hover': {
//               transform: 'translateY(-6px)',
//               boxShadow: '0 12px 24px rgba(30, 144, 255, 0.3)',
//             },
//           }}
//         >
//           <Box sx={{ pt: 4 }}>
//             <Avatar
//               sx={{
//                 backgroundColor: 'transparent',
//                 color: '#1E90FF',
//                 width: 56,
//                 height: 56,
//               }}
//             >
//               {tech.icon}
//             </Avatar>
//           </Box>

//           <CardContent sx={{ px: 4, py: 3 }}>
//             <Typography
//               variant="h6"
//               sx={{
//                 mb: 2,
//                 fontWeight: 600,
//                 letterSpacing: 2,
//                 color: 'white',
//               }}
//             >
//               {tech.title}
//             </Typography>

//             <Typography
//               variant="body2"
//               sx={{
//                 color: '#cfcfcf',
//                 letterSpacing: 1,
//                 lineHeight: 1.7,
//               }}
//             >
//               {tech.content}
//             </Typography>
//           </CardContent>
//         </Card>
//       </SwiperSlide>
//     ))}
//   </Swiper>
// </Container>


// <Container
//       id="future"
//       maxWidth="lg"
//       sx={{
//         bgcolor: 'black',
//         color: 'white',
//         py: { xs: 6, md: 10 },
//         minHeight: '60vh',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         mx: 'auto',
//         mb: 15,
//       }}
//     >
//       <Typography
//         variant="h3"
//         align="center"
//         gutterBottom
//         sx={{
//           letterSpacing: 5,
//           fontWeight: 'bold',
//           textTransform: 'uppercase',
//           color: 'white',
//           position: 'relative',
//           display: 'inline-block',
//           mb: 6,
//           '&::after': {
//             content: '""',
//             position: 'absolute',
//             width: '60%',
//             height: '4px',
//             bottom: -8,
//             left: '20%',
//             background: 'linear-gradient(90deg, #1E90FF, #00C9FF)',
//             borderRadius: 2,
//           },
//           '&:hover': {
//             color: '#1E90FF',
//           },
//         }}
//       >
//         Future Plans
//       </Typography>

//       {/* Single Card Container */}
//       <Box
//         sx={{
//           display: 'flex',
//           justifyContent: 'center',
//           width: '100%',
//         }}
//       >
//         <Card
//           elevation={6}
//           sx={{
//             background: 'linear-gradient(145deg, #000000ff, #000000ff)',
//             borderRadius: '16px',
//             overflow: 'hidden',
//             transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//             display: 'flex',
//             flexDirection: 'column',
//             alignItems: 'center',
//             textAlign: 'center',
//             flex: '1 1 100%',
//             maxWidth: 800,
//             '&:hover': {
//               transform: 'translateY(-6px)',
//               boxShadow: '0 12px 24px rgba(30, 144, 255, 0.3)',
//             },
//           }}
//         >
//           <Box sx={{ pt: 4 }}>
//             <AiOutlineRocket size={60} style={{ color: '#1E90FF' }} />
//           </Box>

//           <CardContent sx={{ px: { xs: 3, md: 5 }, py: 4 }}>
//             <Typography
//               variant="h6"
//               sx={{
//                 mb: 2,
//                 fontWeight: 600,
//                 letterSpacing: 3,
//                 color: 'white',
//                 '&:hover': {
//                   color: '#1E90FF',
//                 },
//               }}
//             >
//               Continuous Upgradation
//             </Typography>

//             <Typography
//               variant="body1"
//               sx={{
//                 color: '#cfcfcf',
//                 letterSpacing: 1,
//                 lineHeight: 1.8,
//                 mb: 3,
//               }}
//             >
//               In the upcoming months, we will be adding new features and continuously upgrading the platform to enhance user experience and performance. Our team is committed to delivering regular improvements, ensuring that you have access to the latest tools and functionalities. Stay tuned as we work to make the platform even more powerful and user-friendly, meeting your evolving needs.
//             </Typography>

//             <Divider sx={{ my: 2, bgcolor: 'grey.700', mx: 'auto', width: '80%' }} />

//             <Typography
//               variant="body2"
//               sx={{
//                 color: '#cfcfcf',
//                 letterSpacing: 1,
//               }}
//             >
//               Stay tuned for updates as we move forward with this exciting journey!
//             </Typography>
//           </CardContent>
//         </Card>
//       </Box>
//     </Container>
//           <Box id="journey">
//             <JourneyPage />

//           </Box>


          
// <Box
//       id="location"
//       sx={{
//         backgroundColor: '#000000',
//         color: 'white',
//         mt: 15,
//         py: { xs: 6, md: 10 },
//         px: { xs: 3, md: 6 },
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//       }}
//     >
//       <Typography
//         variant="h3"
//         align="center"
//         gutterBottom
//         sx={{
//           letterSpacing: 5,
//           fontWeight: 'bold',
//           textTransform: 'uppercase',
//           position: 'relative',
//           display: 'inline-block',
//           mb: 6,
//           '&::after': {
//             content: '""',
//             position: 'absolute',
//             width: '60%',
//             height: '4px',
//             bottom: -8,
//             left: '20%',
//             background: 'linear-gradient(90deg, #1E90FF, #00C9FF)',
//             borderRadius: 2,
//           },
//           '&:hover': {
//             color: '#1E90FF',
//           },
//         }}
//       >
//         Our Location
//       </Typography>

//       {/* Container for address and map */}
//       <Box
//         sx={{
//           display: 'flex',
//           flexDirection: { xs: 'column', md: 'row' },
//           gap: 6,
//           width: '100%',
//           justifyContent: 'center',
//           alignItems: 'flex-start',
//         }}
//       >
//         {/* Address Box */}
//         <Box
//           sx={{
//             flex: 1,
//             background: 'linear-gradient(145deg, #000000ff, #000000ff)',
//             borderRadius: '16px',
//             p: 4,
//             textAlign: 'center',
//             transition: 'transform 0.3s ease, box-shadow 0.3s ease',
//             '&:hover': {
//               transform: 'translateY(-6px)',
//               boxShadow: '0 12px 24px rgba(30, 144, 255, 0.3)',
//             },
//           }}
//         >
//           <LocationOnIcon sx={{ fontSize: 50, color: '#1E90FF' }} />
//           <Typography
//             variant="h6"
//             sx={{
//               mt: 2,
//               fontWeight: 600,
//               color: 'white',
//               letterSpacing: 3,
//               '&:hover': {
//                 color: '#1E90FF',
//               },
//             }}
//           >
//             Registered Address
//           </Typography>
//           <Typography
//             variant="body1"
//             sx={{
//               mt: 2,
//               color: '#cfcfcf',
//               letterSpacing: 2,
//               lineHeight: 1.6,
//             }}
//           >
//             {address}
//           </Typography>
//         </Box>

//         {/* Map Box */}
//         <Box
//           sx={{
//             flex: 1,
//             height: { xs: 300, md: 400 },
//             borderRadius: 2,
//             overflow: 'hidden',
//             minWidth: { xs: '100%', md: 0 },
//           }}
//         >
//           <LoadScript
//             googleMapsApiKey="AIzaSyASEtkoHNy8SPOS-4KBOH7QzCuBdSa8P_A" // Add your API key here
//             onError={() => console.error('Error loading Google Maps')}
//           >
//             <GoogleMap
//               mapContainerStyle={{ width: '100%', height: '100%' }}
//               center={location}
//               zoom={15}
//               options={options}
//             >
//               <Marker position={location} />
//             </GoogleMap>
//           </LoadScript>
//         </Box>
//       </Box>
//     </Box>

//           <Container
//   id="achievements"
//   maxWidth="lg"
//   sx={{
//     bgcolor: 'black',
//     color: 'white',
//     py: { xs: 6, md: 10 },
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     mb: 15,
//   }}
// >
//   <Typography
//     variant="h3"
//     align="center"
//     gutterBottom
//     sx={{
//       letterSpacing: 5,
//       fontWeight: 'bold',
//       textTransform: 'uppercase',
//       position: 'relative',
//       display: 'inline-block',
//       mb: 6,
//       '&::after': {
//         content: '""',
//         position: 'absolute',
//         width: '60%',
//         height: '4px',
//         bottom: -8,
//         left: '20%',
//         background: 'linear-gradient(90deg, #1E90FF, #00C9FF)',
//         borderRadius: 2,
//       },
//       '&:hover': {
//         color: '#1E90FF',
//       },
//     }}
//   >
//     Achievements
//   </Typography>

//   <Grid container spacing={4} justifyContent="center">
//     <Grid item xs={12} sm={10} md={6}>
//       <Box
//         sx={{
//           background: 'linear-gradient(145deg, #000000ff, #000000ff)',
//           color: 'white',
//           borderRadius: '16px',
//           border: '2px solid transparent',
//           transition: 'transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease',
//           '&:hover': {
//             transform: 'translateY(-6px)',
//             borderColor: '#1E90FF',
//             boxShadow: '0 12px 24px rgba(30, 144, 255, 0.3)',
//           },
//         }}
//       >
//         <CardContent sx={{ textAlign: 'center', px: 4, py: 5 }}>
//           <Box sx={{ mb: 2 }}>
//             <AiOutlineTrophy size={60} style={{ color: '#1E90FF' }} />
//           </Box>

//           <Typography
//             variant="h5"
//             sx={{
//               letterSpacing: 3,
//               fontWeight: 600,
//               '&:hover': {
//                 color: '#1E90FF',
//               },
//             }}
//           >
//             Certificate of Recognition
//           </Typography>

//           <Divider sx={{ my: 3, bgcolor: 'grey.700', mx: 'auto', width: '80%' }} />

//           <Box
//             sx={{
//               display: 'inline-block',
//               borderRadius: '10px',
//               overflow: 'hidden',
//               border: '2px solid transparent',
//               transition: 'border-color 0.4s ease-in-out',
//               // '&:hover': {
//               //   borderColor: '#1E90FF',
//               // },
//             }}
//           >
//             <img
//   src={CertificateImage}
//   alt="Startup India Certificate"
//   style={{
//     width: '100%',
//     height: 'auto',
//     borderRadius: '10px',
//     boxShadow: 'rgba(30, 144, 255, 0.4) 0px 4px 10px',
//     transition: 'transform 0.3s ease-in-out',
//   }}
//   onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.2)')}
//   onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
// />

//           </Box>

//           <Box sx={{ mt: 2, mb: 4, textAlign: 'left' }}>
//             <Typography variant="body2" sx={{ color: '#cfcfcf', letterSpacing: 2 }}>
//               <strong>Issued by:</strong> DPIIT
//             </Typography>
//             <Typography variant="body2" sx={{ color: '#cfcfcf', letterSpacing: 2 }}>
//               <strong>Date:</strong> August 17, 2024
//             </Typography>
//           </Box>

//           <Box
//             sx={{
//               display: 'inline-block',
//               borderRadius: '10px',
//               overflow: 'hidden',
//               border: '2px solid transparent',
//               transition: 'border-color 0.4s ease-in-out',
//               // '&:hover': {
//               //   borderColor: '#1E90FF',
//               // },
//             }}
//           >
//             <img
//               src={Startup_Karnataka_Registration}
//               alt="Startup Karnataka Registration"
//               style={{
//                 width: '100%',
//                 height: 'auto',
//                 borderRadius: '10px',
//                 boxShadow: 'rgba(30, 144, 255, 0.4) 0px 4px 10px',
//               }}
//               onMouseEnter={e => (e.currentTarget.style.transform = 'scale(1.1)')}
//   onMouseLeave={e => (e.currentTarget.style.transform = 'scale(1)')}
//             />
//           </Box>

//           <Box sx={{ mt: 2, textAlign: 'left' }}>
//             <Typography variant="body2" sx={{ color: '#cfcfcf', letterSpacing: 2 }}>
//               <strong>Issued by:</strong> Karnataka Startup Cell
//             </Typography>
//             <Typography variant="body2" sx={{ color: '#cfcfcf', letterSpacing: 2 }}>
//               <strong>Date:</strong> September 8, 2025
//             </Typography>
//           </Box>
//         </CardContent>
//       </Box>
//     </Grid>
//   </Grid>
// </Container>
// <AchievementSection2/>

// {/* <Container
//   id="appointments"
//   maxWidth="lg"
//   sx={{
//     bgcolor: 'black',
//     color: 'white',
//     py: { xs: 6, md: 10 },
//     display: 'flex',
//     flexDirection: 'column',
//     alignItems: 'center',
//     mb: 15,
//   }}
// >
//   <Appointments/>
// </Container> */}




//           <style>
//             {`
//               @keyframes curveMove {
//                 0% {
//                   transform: scale(1) translateY(0px);
//                 }
//                 50% {
//                   transform: scale(1.05) translateY(-10px) translateX(10px);
//                 }
//                 100% {
//                   transform: scale(1) translateY(0px);
//                 }
//               }
//             `}
//           </style>

//           <Box sx={{ margin: '40px 0' }} /> {/* Spacer Box */}
//         </div>
//       </div>

//       <Tooltip title="Scroll to Top" placement="top">

//         <IconButton
//           onClick={scrollToTop}
//           sx={{
//             position: 'fixed', bottom: 16, right: 16, backgroundColor: 'white', color: 'black', "&:hover": {
//               color: "#1E90FF",  // Icon color on hover
//             },
//           }}
//         >
//           <ArrowUpwardIcon />
//         </IconButton>
//       </Tooltip>
//       <Footer2 />
//     </div>
//   );
// }

// export default AboutUs;


import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import {
  Tooltip, Box, Typography, Container, IconButton, Avatar,
  AppBar, Toolbar, Button, useTheme, useMediaQuery,
} from '@mui/material';
import backgroundImage      from '../Icon/Background2.png';
import Footer             from './Footer';
import Header               from '../Header/Header';
import Header1              from '../Header/Header1';
import CertificateImage     from '../Icon/Startup_India_Certificate.png';
import Startup_Karnataka_Registration from './Startup_Karnataka_Registration.png';
import VisionBackground     from '../Icon/Vission_latest.png';
import MissionBackground    from '../Icon/mi1.png';
import Slider               from 'react-slick';
import ArrowUpwardIcon      from '@mui/icons-material/ArrowUpward';
import JourneyPage          from '../Home/JourneyPage';
import { FaBrain, FaRobot, FaProjectDiagram } from 'react-icons/fa';
import { MdAssistant, MdDataUsage }           from 'react-icons/md';
import {
  AiOutlineCloud, AiOutlineMobile, AiOutlineApi,
} from 'react-icons/ai';
import {
  Grid, Card, CardContent, CardHeader, Divider, Paper, Icon,
} from '@mui/material';
import {
  AiFillRobot, AiOutlineCode, AiOutlineGlobal, AiOutlineDeploymentUnit,
  AiOutlineBulb, AiOutlineFlag, AiOutlineSafety, AiOutlineUser,
  AiOutlineTeam, AiOutlineRocket, AiOutlineInfoCircle, AiOutlineTrophy,
} from 'react-icons/ai';
import { GoogleMap, LoadScript, Marker, InfoWindow } from '@react-google-maps/api';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { styled }    from '@mui/material/styles';
import { AiOutlineAim, AiOutlineEye } from 'react-icons/ai';
import Appointments        from './Appointments';
import TeamPage            from './TeamPage';
import AchievementSection2 from '../Achievements/AchievementSection2';
import AboutHeroSection    from './AboutHeroSection';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import TeamSection from './TeamSection';

const API_URL = process.env.REACT_APP_API_URL;

/* ─────────────────────────────────────────────────────────────────────────────
   FONTS + GLOBAL CSS
───────────────────────────────────────────────────────────────────────────── */
const Styles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,600;12..96,750;12..96,800&family=DM+Sans:wght@300;400;500;600&display=swap');

    @keyframes auOrb {
      0%,100% { transform:scale(1);   opacity:.45; }
      50%      { transform:scale(1.14); opacity:.75; }
    }
    @keyframes auScan {
      0%   { transform:translateY(110vh); opacity:0;  }
      4%   { opacity:1; }
      94%  { opacity:.6; }
      100% { transform:translateY(-4px);  opacity:0;  }
    }
    @keyframes auIconFloat {
      0%,100% { transform:translateY(0px);  }
      50%      { transform:translateY(-7px); }
    }
    @keyframes auCardPing {
      0%   { transform:scale(1);  opacity:.5; }
      50%  { transform:scale(1.12); opacity:.85; }
      100% { transform:scale(1);  opacity:.5; }
    }
    .au-icon-float { animation:auIconFloat 3.5s ease-in-out infinite; }

    /* Swiper pagination overrides */
    .au-swiper .swiper-pagination-bullet {
      background: rgba(255,255,255,.5) !important;
      width: 8px !important; height: 8px !important;
    }
    .au-swiper .swiper-pagination-bullet-active {
      background: #1E90FF !important;
    }
  `}</style>
);

/* ─────────────────────────────────────────────────────────────────────────────
   DETERMINISTIC PARTICLES (seeded RNG — no Math.random in render)
───────────────────────────────────────────────────────────────────────────── */
const rng = (s) => { const x = Math.sin(s + 1) * 10000; return x - Math.floor(x); };
const PARTICLES = Array.from({ length: 32 }, (_, i) => ({
  id:      i,
  x:       rng(i * 3.14) * 100,
  y:       rng(i * 2.71) * 100,
  size:    rng(i * 1.41) * 2.2 + 0.6,
  opacity: rng(i * 1.61) * 0.14 + 0.03,
  durY:    rng(i * 5.55) * 18 + 12,
  durX:    rng(i * 7.77) * 14 + 8,
  dy:     (rng(i * 4.44) - 0.5) * 44,
  dx:     (rng(i * 6.66) - 0.5) * 26,
  isBlue:  rng(i * 9.99) > 0.5,
  dlyY:    rng(i * 2.22) * -22,
  dlyX:    rng(i * 3.33) * -14,
}));

/* ─────────────────────────────────────────────────────────────────────────────
   FRAMER MOTION HELPERS
───────────────────────────────────────────────────────────────────────────── */
const fadeUp = (delay = 0) => ({
  initial:     { opacity: 0, y: 28 },
  whileInView: { opacity: 1, y: 0  },
  viewport:    { once: true, margin: '-60px' },
  transition:  { duration: 0.68, delay, ease: [0.22, 1, 0.36, 1] },
});

const stagger = {
  hidden:  {},
  visible: { transition: { staggerChildren: 0.1, delayChildren: 0.1 } },
};
const staggerItem = {
  hidden:  { opacity: 0, y: 30, filter: 'blur(4px)' },
  visible: { opacity: 1, y: 0,  filter: 'blur(0px)',
             transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1] } },
};

/* ─────────────────────────────────────────────────────────────────────────────
   REUSABLE PRIMITIVES
───────────────────────────────────────────────────────────────────────────── */

/** Consistent premium section heading */
const SectionHeading = ({ children, delay = 0 }) => (
  <motion.div {...fadeUp(delay)} style={{ textAlign: 'center', width: '100%' }}>
    <Typography
      component="h2"
      sx={{
        fontFamily:   "'Bricolage Grotesque', sans-serif",
        fontWeight:   800,
        fontSize:     { xs: '1.75rem', sm: '2.1rem', md: '2.6rem' },
        letterSpacing: { xs: '2px', md: '4px' },
        textTransform: 'uppercase',
        color:        '#ffffff',
        display:      'inline-block',
        position:     'relative',
        mb:           6,
        '&:hover': { color: '#1E90FF', transition: 'color .3s' },
        '&::after': {
          content:   '""',
          position:  'absolute',
          bottom:    -10,
          left:      '20%',
          width:     '60%',
          height:    '3px',
          background: 'linear-gradient(90deg, transparent, #1E90FF, transparent)',
          borderRadius: 2,
        },
      }}
    >
      {children}
    </Typography>
  </motion.div>
);

/** Premium glassmorphism card */
const GlassCard = ({ children, sx = {}, hoverGlow = true, ...rest }) => (
  <Box
    sx={{
      background:       'rgba(255,255,255,0.03)',
      border:           '1px solid rgba(30,144,255,0.15)',
      backdropFilter:   'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      borderRadius:     '20px',
      overflow:         'hidden',
      position:         'relative',
      transition:       'border-color .25s ease, box-shadow .25s ease, transform .25s ease',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0, left: '15%', right: '15%', height: '1px',
        background: 'linear-gradient(90deg, transparent, rgba(30,144,255,.4), transparent)',
      },
      ...(hoverGlow && {
        '&:hover': {
          borderColor: 'rgba(30,144,255,.38)',
          boxShadow:   '0 14px 50px rgba(30,144,255,.13)',
          transform:   'translateY(-6px)',
        },
      }),
      ...sx,
    }}
    {...rest}
  >
    {children}
  </Box>
);

/** Icon wrapper with ambient glow circle */
const GlowIcon = ({ children, size = 56, delay = 0 }) => (
  <Box
    component={motion.div}
    {...fadeUp(delay)}
    whileHover={{ scale: 1.15 }}
    transition={{ duration: 0.2 }}
    sx={{
      width:  size,
      height: size,
      borderRadius: '16px',
      background:   'rgba(30,144,255,0.1)',
      border:       '1px solid rgba(30,144,255,0.22)',
      display:      'flex',
      alignItems:   'center',
      justifyContent: 'center',
      mx:           'auto',
      mb:           2,
      boxShadow:    '0 0 20px rgba(30,144,255,0.1)',
      animation:    'auCardPing 5s ease-in-out infinite',
    }}
  >
    {children}
  </Box>
);

/* ─────────────────────────────────────────────────────────────────────────────
   BACKGROUND LAYERS (particles + grid + scan + orbs)
───────────────────────────────────────────────────────────────────────────── */
const PageBackground = () => (
  <>
    {/* Grid */}
    <Box aria-hidden sx={{
      position: 'fixed', inset: 0, pointerEvents: 'none', zIndex: 0,
      backgroundImage:
        'linear-gradient(rgba(255,255,255,.016) 1px, transparent 1px),' +
        'linear-gradient(90deg, rgba(255,255,255,.016) 1px, transparent 1px)',
      backgroundSize: '64px 64px',
      maskImage: 'radial-gradient(ellipse 70% 70% at 50% 50%, black, transparent)',
    }}/>

    {/* Scan lines */}
    {[
      { op: .05, dur: 28, dly: 0   },
      { op: .03, dur: 36, dly: -12 },
    ].map((s, i) => (
      <Box key={i} aria-hidden sx={{
        position: 'fixed', left: 0, right: 0, height: '1px',
        background: `linear-gradient(90deg,transparent,rgba(30,144,255,${s.op*2}) 30%,rgba(30,144,255,${s.op}) 50%,rgba(30,144,255,${s.op*2}) 70%,transparent)`,
        animation:      `auScan ${s.dur}s linear infinite`,
        animationDelay: `${s.dly}s`,
        pointerEvents:  'none', zIndex: 0,
        overflow:       'hidden',
      }}/>
    ))}

    {/* Ambient orbs */}
    {[
      { top: '-10%', right: '-8%',  w: 500, bg: 'rgba(30,144,255,0.1)',  dur: 9,  dly: 0    },
      { bottom:'-15%', left:'-8%', w: 420, bg: 'rgba(30,144,255,0.07)', dur: 11, dly: '-4s' },
    ].map((o, i) => (
      <Box key={i} aria-hidden sx={{
        position: 'fixed',
        top:    o.top    ?? 'auto',
        bottom: o.bottom ?? 'auto',
        right:  o.right  ?? 'auto',
        left:   o.left   ?? 'auto',
        width:  { xs: Math.round(o.w*.6), md: o.w },
        height: { xs: Math.round(o.w*.6), md: o.w },
        borderRadius:  '50%',
        background:    `radial-gradient(circle, ${o.bg}, transparent 70%)`,
        filter:        'blur(55px)',
        animation:     `auOrb ${o.dur}s ease-in-out infinite`,
        animationDelay: o.dly ?? 0,
        pointerEvents: 'none', zIndex: 0,
      }}/>
    ))}

    {/* Floating particles */}
    <Box aria-hidden sx={{
      position: 'fixed', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0,
    }}>
      {PARTICLES.map((p) => (
        <Box key={p.id} component={motion.div}
          animate={{ y: [0, p.dy, 0], x: [0, p.dx, 0] }}
          transition={{
            y: { duration: p.durY, repeat: Infinity, ease: 'easeInOut', delay: p.dlyY },
            x: { duration: p.durX, repeat: Infinity, ease: 'easeInOut', delay: p.dlyX },
          }}
          sx={{
            position:     'absolute',
            left:         `${p.x}%`,
            top:          `${p.y}%`,
            width:        `${p.size}px`,
            height:       `${p.size}px`,
            borderRadius: '50%',
            background:   p.isBlue
              ? `rgba(30,144,255,${p.opacity * 3})`
              : `rgba(255,255,255,${p.opacity})`,
            boxShadow: p.isBlue && p.size > 1.8
              ? `0 0 ${p.size * 3}px rgba(30,144,255,0.4)` : 'none',
            willChange: 'transform',
          }}
        />
      ))}
    </Box>
  </>
);

/* ─────────────────────────────────────────────────────────────────────────────
   SLIDER SETTINGS  (preserved exactly)
───────────────────────────────────────────────────────────────────────────── */
const sliderSettings = {
  dots: true, infinite: true, speed: 500,
  slidesToShow: 1, slidesToScroll: 1, arrows: false,
  autoplay: true, autoplaySpeed: 3000,
  appendDots: dots => (
    <div style={{
      position: 'absolute',
      bottom: window.innerWidth < 600 ? '-20px' : window.innerWidth < 960 ? '-25px' : '-30px',
      width: '100%', display: 'flex', justifyContent: 'center',
    }}>
      <ul style={{ margin: '0px', padding: '0px', display: 'flex',
        gap: window.innerWidth < 600 ? '1px' : '5px' }}>
        {dots}
      </ul>
    </div>
  ),
  customPaging: () => (
    <div style={{
      width: '12px', height: '12px', borderRadius: '50%',
      backgroundColor: 'white', opacity: 0.5,
    }}/>
  ),
};
const RECOGNITIONS = [
  {
    name: "Startup India",
    tag: "Government Recognition",
    logo: "/logos/startupindia.png",

    buttonText: "View Recognition",

    url: "https://recognition-be.startupindia.gov.in/s3/download/document/RECOGNITION_CERTIFICATE/4b32be77-1e45-4d03-b539-315ea21a4c55.pdf",
  },

  {
    name: "Startup Karnataka",
    tag: "Innovation Ecosystem",
    logo: "/logos/startupkarnataka.png",

    buttonText: "View Recognition",
    url: "/Startup_Karnataka_Registration.pdf",
  },

  {
    name: "Silicon India",
    tag: "Media Recognition",
    logo: "/logos/siliconindia.png",

    buttonText: "Read Feature",

    url: "https://startup.siliconindia.com/magazine/cover-feature/ai-startups-from-bangalore-2025-anthrasync-cid-26995.html",
  },
];
/* ═════════════════════════════════════════════════════════════════════════════
   MAIN COMPONENT
═════════════════════════════════════════════════════════════════════════════ */
function AboutUs({ userId, loggedIn, onLogout }) {
  const navigate = useNavigate();

  const scrollToTop    = () => window.scrollTo({ top: 0, behavior: 'smooth' });
  const scrollToSection = (id) => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  const handleLogout   = () => { onLogout(); navigate('/login'); };

  const theme         = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const HoverableCardHeader = styled(CardHeader)(({ theme }) => ({
    transition: 'color 0.3s',
    '&:hover .MuiCardHeader-title': { color: '#1E90FF' },
  }));

  const address  = 'No 26, Laskar Hosur Road, Adugodi, Bangalore South, Bengaluru, Karnataka 560030, India';
  const location = { lat: 12.936373, lng: 77.611114 };
  const MAP_LIBRARIES = ['marker'];

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [mapLoaded, setMapLoaded]               = useState(false);

  const darkModeStyles = [
    { elementType: 'geometry',            stylers: [{ color: '#111111' }] },
    { elementType: 'labels.icon',         stylers: [{ visibility: 'off' }] },
    { elementType: 'labels.text.fill',    stylers: [{ color: '#555555' }] },
    { elementType: 'labels.text.stroke',  stylers: [{ color: '#111111' }] },
    { featureType: 'administrative',      elementType: 'geometry',         stylers: [{ visibility: 'off' }] },
    { featureType: 'landscape',           elementType: 'geometry',         stylers: [{ color: '#181818' }] },
    { featureType: 'poi',                 elementType: 'geometry',         stylers: [{ color: '#111111' }] },
    { featureType: 'water',               elementType: 'geometry',         stylers: [{ color: '#000000' }] },
    { featureType: 'road',                elementType: 'geometry',         stylers: [{ color: '#1a1a1a' }] },
    { featureType: 'road',                elementType: 'labels.text.fill', stylers: [{ color: '#666666' }] },
  ];
  const options          = { styles: darkModeStyles, disableDefaultUI: true };
  const mapContainerStyle = { width: '100%', height: '400px' };

  useEffect(() => {
    const checkGoogleMaps = () => {
      if (window.google && window.google.maps) setMapLoaded(true);
      else console.error('Google Maps not loaded yet');
    };
    window.addEventListener('load', checkGoogleMaps);
    return () => window.removeEventListener('load', checkGoogleMaps);
  }, []);

  const technologies = [
    { title: 'Artificial Intelligence',        icon: <FaBrain    size={36} color="#1E90FF"/>, content: 'Building capable and safe AI models for real-world applications.'              },
    { title: 'Machine Learning',               icon: <AiOutlineBulb size={36} color="#1E90FF"/>, content: 'Utilizing ML techniques to enhance user experience and deliver insights.'   },
    { title: 'Natural Language Processing',    icon: <AiOutlineGlobal size={36} color="#1E90FF"/>, content: 'Researching advanced NLP methods to understand and generate human language.' },
    { title: 'Large Language Models (LLMs)',   icon: <AiOutlineCode size={36} color="#1E90FF"/>, content: 'Fine-tuning and building cutting-edge language models for diverse use cases.'  },
    { title: 'AI Agents & Assistants',         icon: <MdAssistant size={36} color="#1E90FF"/>, content: 'Developing intelligent AI agents and virtual assistants for automation and support.' },
    { title: 'Deep Learning',                  icon: <FaRobot    size={36} color="#1E90FF"/>, content: 'Applying deep neural networks to solve complex problems efficiently.'            },
    { title: 'Retrieval-Augmented Generation', icon: <AiOutlineApi size={36} color="#1E90FF"/>, content: 'Building hybrid models combining retrieval and generation techniques.'         },
    { title: 'Data Science',                   icon: <MdDataUsage size={36} color="#1E90FF"/>, content: 'Analyzing and interpreting complex data to optimize AI model performance.'      },
    { title: 'AI Ethics & Safety',             icon: <FaProjectDiagram size={36} color="#1E90FF"/>, content: 'Ensuring responsible, ethical AI design and deployment.'               },
  ];

  const values = [
    { title: 'Freedom',    icon: <AiOutlineFlag   size={36}/>, description: 'The power to act, speak or think as one wants without hindrance or restraint.' },
    { title: 'Discipline', icon: <AiOutlineSafety size={36}/>, description: 'The practice of following a standard code of behavior.'                       },
    { title: 'Equality',   icon: <AiOutlineUser   size={36}/>, description: 'The state of being equal, especially in status, rights and opportunities.'     },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
    const handlePopState = () => navigate('/home');
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [navigate]);

  const items = [
    {
      title: 'Mission',
      text:  'To safely, responsibly, and consciously advance AI and emerging technologies that solve human and environmental challenges, driving inclusive and sustainable progress for all.',
      icon:  <AiOutlineAim size={48} color="#1E90FF"/>,
    },
    {
      title: 'Vision',
      text:  'To harness the advancement of technology for the betterment of humanity and nature, ensuring innovation remains safe, responsible, conscious, inclusive, and beneficial to all.',
      icon:  <AiOutlineEye size={48} color="#1E90FF"/>,
    },
  ];

  /* ── shared swiper styles ── */
  const swiperPaginationVars = {
    '--swiper-pagination-color':                  '#1E90FF',
    '--swiper-pagination-bullet-inactive-color':  '#ffffff',
    '--swiper-pagination-bullet-inactive-opacity': '0.5',
    '--swiper-pagination-bullet-size':            '9px',
    '--swiper-pagination-bullet-horizontal-gap':  '6px',
    paddingBottom: '56px',
  };

  /* ── section wrapper ── */
  const SectionWrap = ({ id, children, sx = {} }) => (
    <Container
      id={id}
      maxWidth="lg"
      sx={{
        py:     { xs: 8, md: 12 },
        mb:     { xs: 4, md: 8  },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        ...sx,
      }}
    >
      {children}
    </Container>
  );

  /* ═════════════════════════════ RENDER ═════════════════════════════ */
  return (
    <Box sx={{ bgcolor: '#000000', color: '#ffffff', fontFamily: "'DM Sans', sans-serif", overflowX: 'hidden' }}>
      <Styles />
      <PageBackground />

      {/* ── fixed-position elements sit below content ── */}
      <Box sx={{ position: 'relative', zIndex: 1 }}>
        <Header1 />
        <AboutHeroSection />

        {/* ════════════════════════════════════════════════════════════
            MAIN CONTENT
        ════════════════════════════════════════════════════════════ */}
        <Box sx={{ bgcolor: '#000000', position: 'relative', zIndex: 1, pt: { xs: 4, md: 6 } }}>

          {/* ── MISSION & VISION ── */}

           <SectionWrap id="mission_and_vision">
  <SectionHeading>Mission & Vision</SectionHeading>

  <Box
    component={motion.div}
    variants={stagger}
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: "-60px" }}
    sx={{
      position: "relative",
      width: "100%",
      mt: { xs: 4, md: 8 },
    }}
  >
    {/* Ambient Center Glow */}
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: { xs: 280, md: 520 },
        height: { xs: 280, md: 520 },
        borderRadius: "50%",
        background:
          "radial-gradient(circle, rgba(30,144,255,0.12), transparent 70%)",
        filter: "blur(90px)",
        pointerEvents: "none",
        zIndex: 0,
      }}
    />

    {/* Floating Particles */}
    {[...Array(12)].map((_, i) => (
      <Box
        key={i}
        component={motion.div}
        animate={{
          y: [0, -20, 0],
          opacity: [0.3, 1, 0.3],
        }}
        transition={{
          duration: 4 + i,
          repeat: Infinity,
          ease: "easeInOut",
        }}
        sx={{
          position: "absolute",
          width: 4,
          height: 4,
          borderRadius: "50%",
          background: "#1E90FF",
          top: `${10 + i * 6}%`,
          left: `${5 + i * 8}%`,
          boxShadow: "0 0 10px #1E90FF",
          zIndex: 0,
        }}
      />
    ))}

    <Box
      sx={{
        position: "relative",
        zIndex: 2,
        display: "flex",
        flexDirection: {
          xs: "column",
          md: "row",
        },
        alignItems: "center",
        justifyContent: "center",
        gap: {
          xs: 6,
          md: 8,
        },
      }}
    >
      {/* MISSION */}
      <motion.div
        variants={staggerItem}
        style={{ flex: 1, width: "100%" }}
      >
        <Box
          sx={{
            position: "relative",
            textAlign: "center",
            px: { xs: 2, md: 5 },
            py: { xs: 4, md: 5 },
            transition: "all .35s ease",
            "&:hover": {
              transform: "translateY(-8px)",
            },
            "&:hover .pillar-icon": {
              transform: "scale(1.12)",
            },
          }}
        >
          {/* Glow */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              borderRadius: "32px",
              background:
                "radial-gradient(circle at top, rgba(30,144,255,0.08), transparent 65%)",
              filter: "blur(40px)",
            }}
          />

          {/* Icon */}
          <Box
            className="pillar-icon"
            sx={{
              transition: ".4s ease",
              display: "flex",
              justifyContent: "center",
              mb: 3,
            }}
          >
            <Box
              sx={{
                width: 90,
                height: 90,
                borderRadius: "50%",
                background:
                  "radial-gradient(circle, rgba(30,144,255,0.18), rgba(30,144,255,0.03))",
                border: "1px solid rgba(30,144,255,0.25)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow:
                  "0 0 35px rgba(30,144,255,0.18)",
              }}
            >
              {items[0].icon}
            </Box>
          </Box>

          <Typography
            sx={{
              fontFamily: "'Bricolage Grotesque', sans-serif",
              fontWeight: 800,
              fontSize: {
                xs: "2rem",
                md: "2.4rem",
              },
              color: "#fff",
              letterSpacing: "-1px",
            }}
          >
            {items[0].title}
          </Typography>

          <Box
            sx={{
              width: 70,
              height: 3,
              mx: "auto",
              mt: 2,
              mb: 3,
              borderRadius: 999,
              background:
                "linear-gradient(90deg,#1E90FF,#5DB7FF)",
            }}
          />

          <Typography
            sx={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: {
                xs: "1rem",
                md: "1.08rem",
              },
              lineHeight: 1.95,
              color: "rgba(255,255,255,.75)",
              maxWidth: 500,
              mx: "auto",
            }}
          >
            {items[0].text}
          </Typography>
        </Box>
      </motion.div>

      {/* CENTER DIVIDER */}
      <Box
        sx={{
          display: {
            xs: "none",
            md: "block",
          },
          width: "1px",
          height: 320,
          background:
            "linear-gradient(to bottom, transparent, rgba(30,144,255,.8), transparent)",
          boxShadow:
            "0 0 25px rgba(30,144,255,.5)",
        }}
      />

      {/* VISION */}
      <motion.div
        variants={staggerItem}
        style={{ flex: 1, width: "100%" }}
      >
        <Box
          sx={{
            position: "relative",
            textAlign: "center",
            px: { xs: 2, md: 5 },
            py: { xs: 4, md: 5 },
            transition: "all .35s ease",
            "&:hover": {
              transform: "translateY(-8px)",
            },
            "&:hover .pillar-icon": {
              transform: "scale(1.12)",
            },
          }}
        >
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              borderRadius: "32px",
              background:
                "radial-gradient(circle at top, rgba(30,144,255,0.08), transparent 65%)",
              filter: "blur(40px)",
            }}
          />

          <Box
            className="pillar-icon"
            sx={{
              transition: ".4s ease",
              display: "flex",
              justifyContent: "center",
              mb: 3,
            }}
          >
            <Box
              sx={{
                width: 90,
                height: 90,
                borderRadius: "50%",
                background:
                  "radial-gradient(circle, rgba(30,144,255,0.18), rgba(30,144,255,0.03))",
                border: "1px solid rgba(30,144,255,0.25)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxShadow:
                  "0 0 35px rgba(30,144,255,0.18)",
              }}
            >
              {items[1].icon}
            </Box>
          </Box>

          <Typography
            sx={{
              fontFamily: "'Bricolage Grotesque', sans-serif",
              fontWeight: 800,
              fontSize: {
                xs: "2rem",
                md: "2.4rem",
              },
              color: "#fff",
              letterSpacing: "-1px",
            }}
          >
            {items[1].title}
          </Typography>

          <Box
            sx={{
              width: 70,
              height: 3,
              mx: "auto",
              mt: 2,
              mb: 3,
              borderRadius: 999,
              background:
                "linear-gradient(90deg,#1E90FF,#5DB7FF)",
            }}
          />

          <Typography
            sx={{
              fontFamily: "'DM Sans', sans-serif",
              fontSize: {
                xs: "1rem",
                md: "1.08rem",
              },
              lineHeight: 1.95,
              color: "rgba(255,255,255,.75)",
              maxWidth: 500,
              mx: "auto",
            }}
          >
            {items[1].text}
          </Typography>
        </Box>
      </motion.div>
    </Box>
  </Box>
</SectionWrap> 
    {/* ── OUR TEAM ── */}
     {/* ── OUR TEAM ── */}
<SectionWrap id="team">
            <SectionHeading delay={0.05}>Our Team</SectionHeading>

            <motion.div {...fadeUp(0.15)} style={{ width: '100%', maxWidth: 760 }}>
              <GlassCard sx={{ p: { xs: 4, sm: 5 }, textAlign: 'center', mx: 'auto' }}>
                <Box sx={{
                  position: 'absolute', top: -50, left: '50%', transform: 'translateX(-50%)',
                  width: 240, height: 240, borderRadius: '50%',
                  background: 'radial-gradient(circle, rgba(30,144,255,0.08), transparent 70%)',
                  filter: 'blur(35px)', pointerEvents: 'none',
                }}/>

                <Box className="au-icon-float" sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
                  <Box sx={{
                    width: 72, height: 72, borderRadius: '20px',
                    background:   'rgba(30,144,255,0.1)',
                    border:       '1px solid rgba(30,144,255,0.25)',
                    display:      'flex',
                    alignItems:   'center',
                    justifyContent: 'center',
                    boxShadow:    '0 0 20px rgba(30,144,255,0.15)',
                  }}>
                    <AiOutlineTeam size={40} style={{ color: '#1E90FF' }}/>
                  </Box>
                </Box>

                <Typography sx={{
                  fontFamily:    "'Bricolage Grotesque', sans-serif",
                  fontWeight:    700,
                  fontSize:      { xs: '1.2rem', md: '1.4rem' },
                  letterSpacing: '3px',
                  color:         '#ffffff',
                  mb:            2.5,
                  '&:hover':     { color: '#1E90FF', transition: 'color .3s' },
                }}>
                  Passionate &amp; Dedicated
                </Typography>

                <Box sx={{ height: '1px', background: 'linear-gradient(90deg,transparent,rgba(30,144,255,.3),transparent)', mb: 3 }}/>

                <Typography sx={{
                  fontFamily:  "'DM Sans', sans-serif",
                  color:       'rgba(255,255,255,0.62)',
                  lineHeight:  1.85,
                  letterSpacing: '0.02em',
                  fontSize:    { xs: '0.92rem', md: '0.97rem' },
                }}>
                  Our team at Anthrasync consists of highly passionate, dedicated and motivated individuals who are
                  continuously working towards one common goal. We are always willing to take risks, face challenges
                  and overcome them. We make sure that we are regularly updating our skills and are part of a
                  continuous process of learning and growth.
                </Typography>
              </GlassCard>
            </motion.div>
          </SectionWrap>

          {/* ── CORE VALUES ── */}
          <SectionWrap id="values">
            <SectionHeading delay={0.05}>Our Core Values</SectionHeading>

            <Box sx={{ width: '100%', maxWidth: '1100px' }}>
              <Swiper
                className="au-swiper"
                modules={[Pagination, Autoplay]}
                spaceBetween={24}
                pagination={{ clickable: true }}
                autoplay={{ delay: 3500, disableOnInteraction: false }}
                breakpoints={{ 0: { slidesPerView: 1 }, 600: { slidesPerView: 2 }, 960: { slidesPerView: 3 } }}
                style={swiperPaginationVars}
              >
                {values.map((value, i) => (
                  <SwiperSlide key={i}>
                    <GlassCard sx={{
                      p:             { xs: 3.5, md: 4 },
                      textAlign:     'center',
                      display:       'flex',
                      flexDirection: 'column',
                      alignItems:    'center',
                      minHeight:     220,
                    }}>
                      <Box sx={{
                        width: 60, height: 60, borderRadius: '16px',
                        background:   'rgba(30,144,255,0.1)',
                        border:       '1px solid rgba(30,144,255,0.22)',
                        display:      'flex',
                        alignItems:   'center',
                        justifyContent: 'center',
                        mb:           2.5,
                        boxShadow:    '0 0 16px rgba(30,144,255,0.12)',
                        color:        '#1E90FF',
                        className:    'au-icon-float',
                      }}>
                        {value.icon}
                      </Box>
                      <Typography sx={{
                        fontFamily:    "'Bricolage Grotesque', sans-serif",
                        fontWeight:    700,
                        fontSize:      '1.05rem',
                        letterSpacing: '2px',
                        color:         '#ffffff',
                        mb:            1.5,
                      }}>
                        {value.title}
                      </Typography>
                      <Box sx={{ height: '1px', width: '60%', background: 'linear-gradient(90deg,transparent,rgba(30,144,255,.3),transparent)', mb: 2 }}/>
                      <Typography sx={{
                        fontFamily: "'DM Sans', sans-serif",
                        color:      'rgba(255,255,255,0.58)',
                        fontSize:   '0.87rem',
                        lineHeight: 1.72,
                        letterSpacing: '0.02em',
                      }}>
                        {value.description}
                      </Typography>
                    </GlassCard>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Box>
          </SectionWrap>

          {/* ── TECHNOLOGIES ── */}
          <SectionWrap id="technologies">
            <SectionHeading delay={0.05}>Technologies We Deal With</SectionHeading>

            <Box sx={{ width: '100%', maxWidth: '1100px' }}>
              <Swiper
                className="au-swiper"
                modules={[Pagination, Autoplay]}
                spaceBetween={24}
                pagination={{ clickable: true }}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                breakpoints={{ 0: { slidesPerView: 1 }, 600: { slidesPerView: 2 }, 960: { slidesPerView: 3 }, 1280: { slidesPerView: 4 } }}
                style={swiperPaginationVars}
              >
                {technologies.map((tech, i) => (
                  <SwiperSlide key={i}>
                    <GlassCard sx={{
                      p:             { xs: 3, md: 3.5 },
                      textAlign:     'center',
                      display:       'flex',
                      flexDirection: 'column',
                      alignItems:    'center',
                      minHeight:     210,
                    }}>
                      <Box sx={{
                        width: 60, height: 60, borderRadius: '16px',
                        background: 'rgba(30,144,255,0.09)',
                        border:     '1px solid rgba(30,144,255,0.2)',
                        display:    'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb:         2.5,
                        transition: 'transform .2s ease, box-shadow .2s ease',
                        '&:hover':  { transform: 'scale(1.12)', boxShadow: '0 0 20px rgba(30,144,255,0.25)' },
                      }}>
                        {tech.icon}
                      </Box>
                      <Typography sx={{
                        fontFamily:    "'Bricolage Grotesque', sans-serif",
                        fontWeight:    700,
                        fontSize:      '0.95rem',
                        letterSpacing: '1.5px',
                        color:         '#ffffff',
                        mb:            1.5,
                      }}>
                        {tech.title}
                      </Typography>
                      <Typography sx={{
                        fontFamily: "'DM Sans', sans-serif",
                        color:      'rgba(255,255,255,0.55)',
                        fontSize:   '0.83rem',
                        lineHeight: 1.7,
                      }}>
                        {tech.content}
                      </Typography>
                    </GlassCard>
                  </SwiperSlide>
                ))}
              </Swiper>
            </Box>
          </SectionWrap>

          {/* ── FUTURE PLANS ── */}
          <SectionWrap id="future">
            <SectionHeading delay={0.05}>Future Plans</SectionHeading>

            <motion.div {...fadeUp(0.18)} style={{ width: '100%', maxWidth: 780 }}>
              <GlassCard sx={{ p: { xs: 4, md: 5 }, background: 'rgba(30,144,255,0.04)', border: '1px solid rgba(30,144,255,0.2)' }}>
                {/* Blueprint glow */}
                <Box sx={{
                  position: 'absolute', top: -60, right: -40,
                  width: 200, height: 200, borderRadius: '50%',
                  background: 'radial-gradient(circle, rgba(30,144,255,0.12), transparent 70%)',
                  filter: 'blur(30px)', pointerEvents: 'none',
                }}/>

                <Box className="au-icon-float" sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
                  <Box sx={{
                    width: 68, height: 68, borderRadius: '18px',
                    background: 'rgba(30,144,255,0.1)',
                    border:     '1px solid rgba(30,144,255,0.25)',
                    display:    'flex', alignItems: 'center', justifyContent: 'center',
                    boxShadow:  '0 0 18px rgba(30,144,255,0.18)',
                  }}>
                    <AiOutlineRocket size={36} style={{ color: '#1E90FF' }}/>
                  </Box>
                </Box>

                <Typography sx={{
                  fontFamily:    "'Bricolage Grotesque', sans-serif",
                  fontWeight:    700,
                  fontSize:      { xs: '1.2rem', md: '1.4rem' },
                  letterSpacing: '3px',
                  textAlign:     'center',
                  color:         '#ffffff',
                  mb:            3,
                  '&:hover':     { color: '#1E90FF', transition: 'color .3s' },
                }}>
                  Continuous Upgradation
                </Typography>

                <Box sx={{ height: '1px', background: 'linear-gradient(90deg,transparent,rgba(30,144,255,.35),transparent)', mb: 3 }}/>

                <Typography sx={{
                  fontFamily:  "'DM Sans', sans-serif",
                  color:       'rgba(255,255,255,0.65)',
                  lineHeight:  1.85,
                  letterSpacing: '0.02em',
                  fontSize:    { xs: '0.92rem', md: '0.97rem' },
                  textAlign:   'center',
                  mb:          3,
                }}>
                  In the upcoming months, we will be adding new features and continuously upgrading the platform
                  to enhance user experience and performance. Our team is committed to delivering regular improvements,
                  ensuring that you have access to the latest tools and functionalities. Stay tuned as we work to make
                  the platform even more powerful and user-friendly, meeting your evolving needs.
                </Typography>

                <Box sx={{ height: '1px', background: 'rgba(255,255,255,0.06)', mb: 3 }}/>

                <Typography sx={{
                  fontFamily:  "'DM Sans', sans-serif",
                  color:       'rgba(30,144,255,0.7)',
                  fontSize:    '0.85rem',
                  letterSpacing: '0.06em',
                  textAlign:   'center',
                  fontStyle:   'italic',
                }}>
                  Stay tuned for updates as we move forward with this exciting journey!
                </Typography>
              </GlassCard>
            </motion.div>
          </SectionWrap>

          {/* ── JOURNEY ── */}
          <Box id="journey" sx={{ position: 'relative', zIndex: 1 }}>
            <JourneyPage />
          </Box>

       {/* <TeamSection/>
          */}

                    <SectionWrap id="achievements">
  <SectionHeading delay={0.05}>
    Achievements
  </SectionHeading>

  <Container>
<Box
  sx={{
    display: "grid",
    gridTemplateColumns: {
      xs: "1fr",
      sm: "repeat(2,1fr)",
      lg: "repeat(3,1fr)",
    },
    gap: {
      xs: 2,
      sm: 2.5,
      md: 3,
    },
  }}
>
  {RECOGNITIONS.map((item, index) => (
    <Box
      key={item.name}
      component={motion.div}
      initial={{
        opacity: 0,
        y: 20,
      }}
      whileInView={{
        opacity: 1,
        y: 0,
      }}
      viewport={{
        once: true,
      }}
      transition={{
        duration: 0.55,
        delay: index * 0.08,
      }}
      whileHover={{
        y: -5,
        scale: 1.02,
      }}
      sx={{
        position: "relative",
        overflow: "hidden",
        borderRadius: {
          xs: "20px",
          md: "24px",
        },
        p: {
          xs: 3,
          md: 4,
        },
        minHeight: {
          xs: 220,
          sm: 240,
          md: 260,
        },
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
        background: "rgba(8,8,8,.95)",
        border: "1px solid rgba(30,144,255,.14)",
        backdropFilter: "blur(18px)",
        boxShadow: "0 10px 40px rgba(0,0,0,.45)",
        transition: ".3s ease",
        "&:hover": {
          borderColor: "rgba(30,144,255,.35)",
          boxShadow:
            "0 15px 50px rgba(30,144,255,.16)",
        },
      }}
    >
      {/* glow */}
      <Box
        sx={{
          position: "absolute",
          width: {
            xs: 120,
            md: 180,
          },
          height: {
            xs: 120,
            md: 180,
          },
          borderRadius: "50%",
          background:
            "radial-gradient(circle, rgba(30,144,255,.16), transparent 70%)",
          top: -90,
          right: -90,
          pointerEvents: "none",
        }}
      />

      {/* logo */}
      <Box
        sx={{
          mb: {
            xs: 2.5,
            md: 3,
          },
          height: {
            xs: 46,
            md: 54,
          },
          display: "flex",
          alignItems: "center",
        }}
      >
        <Box
          component="img"
          src={item.logo}
          alt={item.name}
          sx={{
            maxWidth: {
              xs: 130,
              md: 170,
            },
            maxHeight: {
              xs: 42,
              md: 48,
            },
            width: "auto",
            height: "auto",
            objectFit: "contain",
            filter:
              item.name === "Silicon India"
                ? "brightness(1.3)"
                : "brightness(1.05)",
            background:
              item.name === "Silicon India" ||
              item.name === "Startup Karnataka"
                ? "#ffffff"
                : "transparent",
            padding:
              item.name === "Silicon India" ||
              item.name === "Startup Karnataka"
                ? "6px 10px"
                : 0,
            borderRadius:
              item.name === "Silicon India" ||
              item.name === "Startup Karnataka"
                ? "10px"
                : 0,
          }}
        />
      </Box>

      {/* title */}
      <Typography
        sx={{
          fontFamily:
            "'Bricolage Grotesque', sans-serif",
          fontWeight: 700,
          color: "#FFFFFF",
          fontSize: {
            xs: "1rem",
            md: "1.15rem",
          },
          lineHeight: 1.3,
          mb: 1.1,
        }}
      >
        {item.name}
      </Typography>

      {/* tag */}
      <Typography
        sx={{
          fontFamily: "'DM Sans', sans-serif",
          color: "rgba(210,230,255,.65)",
          fontSize: {
            xs: ".84rem",
            md: ".92rem",
          },
          lineHeight: 1.7,
        }}
      >
        {item.tag}
      </Typography>

      <Button
        variant="contained"
        component={motion.a}
        whileHover={{
          scale: 1.03,
        }}
        whileTap={{
          scale: 0.98,
        }}
        href={item.url}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          mt: {
            xs: 2.5,
            md: 3,
          },
          width: "fit-content",
          alignSelf: "flex-start",
          background:
            "linear-gradient(90deg,#1E90FF 0%,#42A5FF 100%)",
          color: "#FFFFFF",
          textTransform: "none",
          fontFamily:
            "'DM Sans', sans-serif",
          fontWeight: 700,
          fontSize: {
            xs: ".82rem",
            md: ".88rem",
          },
          px: {
            xs: 2.2,
            md: 2.6,
          },
          py: {
            xs: 0.9,
            md: 1,
          },
          borderRadius: "12px",
          boxShadow:
            "0px 8px 25px rgba(30,144,255,.22)",
          border:
            "1px solid rgba(255,255,255,.08)",
          transition: ".25s ease",
          "&:hover": {
            background:
              "linear-gradient(90deg,#42A5FF 0%,#1E90FF 100%)",
            boxShadow:
              "0px 14px 35px rgba(30,144,255,.34)",
          },
        }}
      >
        {item.buttonText}
      </Button>
    </Box>
  ))}
</Box>
  </Container>

  <Box
    sx={{
      position: "absolute",
      bottom: 0,
      left: "50%",
      transform: "translateX(-50%)",
      width: {
        xs: "88%",
        sm: "82%",
        md: "60%",
      },
      height: "1px",
      background:
        "linear-gradient(to right, transparent, rgba(30,144,255,.14), transparent)",
    }}
  />
</SectionWrap>

          {/* ── LOCATION ── */}
          <Box
            id="location"
            component={Container}
            maxWidth="lg"
            sx={{
              py:     { xs: 8, md: 12 },
              mb:     { xs: 4, md: 8  },
              display: 'flex',
              flexDirection: 'column',
              alignItems:    'center',
            }}
          >
            <SectionHeading delay={0.05}>Our Location</SectionHeading>

            <Box
              component={motion.div}
              variants={stagger}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: '-60px' }}
              sx={{
                display:       'flex',
                flexDirection: { xs: 'column', md: 'row' },
                gap:           { xs: 3, md: 5 },
                width:         '100%',
              }}
            >
              {/* Address card */}
              <motion.div variants={staggerItem} style={{ flex: 1 }}>
                <GlassCard sx={{
                  p:          { xs: 4, md: 5 },
                  textAlign:  'center',
                  height:     '100%',
                  background: 'rgba(30,144,255,0.04)',
                  border:     '1px solid rgba(30,144,255,0.18)',
                }}>
                  <Box sx={{
                    width: 60, height: 60, borderRadius: '16px',
                    background: 'rgba(30,144,255,0.1)',
                    border:     '1px solid rgba(30,144,255,0.22)',
                    display:    'flex', alignItems: 'center', justifyContent: 'center',
                    mx:         'auto', mb: 3,
                    boxShadow:  '0 0 16px rgba(30,144,255,0.15)',
                  }}>
                    <LocationOnIcon sx={{ fontSize: 32, color: '#1E90FF' }}/>
                  </Box>

                  <Typography sx={{
                    fontFamily:    "'Bricolage Grotesque', sans-serif",
                    fontWeight:    700,
                    fontSize:      { xs: '1rem', md: '1.1rem' },
                    letterSpacing: '3px',
                    color:         '#ffffff',
                    mb:            2,
                  }}>
                    Registered Address
                  </Typography>

                  <Box sx={{ height: '1px', background: 'linear-gradient(90deg,transparent,rgba(30,144,255,.3),transparent)', mb: 2.5 }}/>

                      <strong style={{ color: "#fff" }}>
    Anthrasync Solutions Private Limited
  </strong>
                  <Typography sx={{
                    fontFamily:  "'DM Sans', sans-serif",
                    color:       'rgba(255,255,255,0.6)',
                    letterSpacing: '0.04em',
                    lineHeight:  1.8,
                    fontSize:    { xs: '0.88rem', md: '0.93rem' },
                  }}>
                    {address}
                     <br />
  



  <br />

  <strong style={{ color: "#1E90FF" }}>CIN:</strong>{" "}
  U62091KA2024PTC190833

  <br />

  <strong style={{ color: "#1E90FF" }}>GSTIN:</strong>{" "}
  29ABBCA0435C1Z8
                  </Typography>
                </GlassCard>
              </motion.div>

              {/* Map */}
              <motion.div variants={staggerItem} style={{ flex: 1 }}>
                <Box sx={{
                  borderRadius: '20px',
                  overflow:     'hidden',
                  height:       { xs: 300, md: '100%' },
                  minHeight:    { md: 360 },
                  border:       '1px solid rgba(30,144,255,0.18)',
                  boxShadow:    '0 0 30px rgba(30,144,255,0.08)',
                }}>
                  <LoadScript
                    googleMapsApiKey="AIzaSyASEtkoHNy8SPOS-4KBOH7QzCuBdSa8P_A"
                    onError={() => console.error('Error loading Google Maps')}
                  >
                    <GoogleMap
                      mapContainerStyle={{ width: '100%', height: '100%' }}
                      center={location}
                      zoom={15}
                      options={options}
                    >
                      <Marker position={location}/>
                    </GoogleMap>
                  </LoadScript>
                </Box>
              </motion.div>
            </Box>
          </Box>

          {/* ── ACHIEVEMENTS ── */}

          {/* <AchievementSection2/> */}

          {/* Bottom spacer */}
          <Box sx={{ height: { xs: 40, md: 80 } }}/>
        </Box>

        {/* ── Scroll-to-top ── */}
        <Tooltip title="Scroll to Top" placement="top">
          <IconButton
            onClick={scrollToTop}
            sx={{
              position:        'fixed',
              bottom:          24,
              right:           24,
              width:           44,
              height:          44,
              backgroundColor: 'rgba(30,144,255,0.12)',
              border:          '1px solid rgba(30,144,255,0.3)',
              backdropFilter:  'blur(12px)',
              color:           '#1E90FF',
              zIndex:          9999,
              transition:      'all .25s ease',
              '&:hover': {
                backgroundColor: 'rgba(30,144,255,0.2)',
                boxShadow:       '0 0 20px rgba(30,144,255,0.3)',
                transform:       'translateY(-3px)',
              },
            }}
          >
            <ArrowUpwardIcon fontSize="small"/>
          </IconButton>
        </Tooltip>

        <Footer/>
      </Box>

      {/* ── curveMove keyframe (preserved) ── */}
      <style>{`
        @keyframes curveMove {
          0%   { transform:scale(1)    translateY(0px); }
          50%  { transform:scale(1.05) translateY(-10px) translateX(10px); }
          100% { transform:scale(1)    translateY(0px); }
        }
      `}</style>
    </Box>
  );
}

export default AboutUs;